import { PAYMENT_PROVIDER_IDS } from '../const';

const providerNames: Record<number, string> = {
  [PAYMENT_PROVIDER_IDS.CRYPTO]: 'provider.name.crypto',
  //[PAYMENT_PROVIDER_IDS.PAYZE]: 'provider.name.payze',
  [PAYMENT_PROVIDER_IDS.STRIPE]: 'provider.name.stripe',
};

const getProviderName = (id: number): string => {
  return providerNames[id];
};

export { getProviderName };
